import type { App } from 'vue'
import SvgIcon from './index.vue'

export const setupSvgIcon = (app: App<Element>) => {
  app.component('svg-icon', SvgIcon)
}
